import { format } from 'date-fns';
import { MetricSummary } from 'entities/MetricSummary';
import { MetricTypeEnum } from 'enums/MetricTypeEnum';
import { apiMetrics } from 'services/apiMetrics';

interface GetMetricSummaryProps {
  patientId: string;
  metricType: MetricTypeEnum;
  startDate: Date;
  endDate: Date;
}

/**
 * Mínimo, máximo e último do período, calculados no metrics sobre **todas** as
 * leituras (`GET /metrics/summary`). As duas datas são inclusivas e vão como dia de
 * calendário (`yyyy-MM-dd`), no fuso de quem olha.
 *
 * ⚠️ **Lança o erro**, como `getMetricValuesByRange`: um quadro vazio por falha não
 * pode se passar por "sem leituras".
 */
export const getMetricSummary = async ({
  patientId,
  metricType,
  startDate,
  endDate,
}: GetMetricSummaryProps): Promise<MetricSummary> => {
  const { data } = await apiMetrics.get(
    `/metrics/summary/${patientId}/${metricType}/${format(
      startDate,
      'yyyy-MM-dd',
    )}/${format(endDate, 'yyyy-MM-dd')}`,
  );

  return data;
};
